// extracted by mini-css-extract-plugin
module.exports = {"note":"_22Swy","button":"_2zjs7","body":"CVgOs","icon":"TUZIb"};